import BaseService from './_base.service';

export const serierankingDayService = {
    page,
    edit,
    search,
    create,
    combo,
    one,
    remove,
    removeLogic,
    allFilter
};

function page(page,size, callback) {
    return BaseService.get("/serierankingday/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/serierankingday/page/"+page+"/"+size,filter, callback, true)
}
function allFilter(filter, callback) {
    return BaseService.post("/serierankingday/all",filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/serierankingday/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/serierankingday/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/serierankingday/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/serierankingday/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/serierankingday/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/serierankingday/"+id+"/logic", callback);
}
